import Auth from "../utils/Auth";
import { AppConstants } from '../constants/AppConstants';
import { DataService } from '../services/DataService';
import * as XLSX from 'xlsx';

export const FileOperationsUtil = {
    //Method to download authorized file using GET method
    async downloadFile(uri, fileName, invalidResponse, noResponse, requestHeaders) {
        const apiURL = process.env.REACT_APP_API_URL;
        const url = `${apiURL}` + uri;
        const token = `Bearer ${Auth.getAuthToken()}`;

        try {
            let header = { 'Authorization': token };
            if (requestHeaders && Object.keys(requestHeaders)?.length > 0) {
                header = { ...header, ...requestHeaders }
            }

            const response = await fetch(url, { headers: header });
            if (response.ok) {
                const data = await response.arrayBuffer();
                const viewDocument = new Blob([data]);
                let downloadURL = URL.createObjectURL(viewDocument);
                let link = document.createElement('a');
                link.href = downloadURL;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                return await response;
            }
            else {
                throw new Error(invalidResponse);
            }
        } catch (error) {
            console.error(noResponse, error);
        }
    },

    async downloadFileUsingPostRequest(uri, fileName, data, invalidResponse, noResponse) {
        const apiURL = process.env.REACT_APP_API_URL;
        const url = `${apiURL}` + uri;
        const token = `Bearer ${Auth.getAuthToken()}`;
        try {
            const header = { 'Authorization': token, 'Content-Type': 'application/json' };
            const response = await fetch(url, {
                headers: header, method: 'POST',
                body: JSON.stringify(data)
            });
            if (response.ok) {
                const data = await response.arrayBuffer();
                const viewDocument = new Blob([data]);
                let downloadURL = URL.createObjectURL(viewDocument);
                let link = document.createElement('a');
                link.href = downloadURL;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                return response;
            }
            else {
                throw new Error(invalidResponse);
            }
        } catch (error) {
            console.error(noResponse, error);
        }
    },

    //Method to download files
    async downloadDocument(fileUrl, FileTitle, suffix) {
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            let name = `${FileTitle}${AppConstants.hyphen}${suffix}`;
            let fileName = name.replace(/\s+/g, AppConstants.hyphen);
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(url); // Clean up the temporary URL
        } catch (error) {
            return error;
        }
    },

    //Method to download un-authorized file using GET method
    async downloadFileUnauthorized(uri, fileName, invalidResponse, noResponse) {
        const apiURL = process.env.REACT_APP_API_URL;
        const url = `${apiURL}` + uri;
        try {
            const response = await fetch(url);
            if (response.ok) {
                const data = await response.arrayBuffer();
                const viewDocument = new Blob([data]);
                let downloadURL = URL.createObjectURL(viewDocument);
                let link = document.createElement('a');
                link.href = downloadURL;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                return await response;
            }
            else {
                throw new Error(invalidResponse);
            }
        } catch (error) {
            console.error(noResponse, error);
        }
    },
    getFileType(file) {
        // Get the file extension
        const extension = file.name.split('.').pop();
        // Return the content type for the file extension
        return AppConstants.contentTypeMap[extension];
    },
    async downloadFileFromS3(presignedUrl, fileName, fileExtension) {
        try {
            const response = await fetch(presignedUrl);
            if (response.ok) {
                const blob = await response.blob();

                // Create a temporary anchor element to initiate the download
                const anchor = document.createElement('a');
                anchor.href = URL.createObjectURL(blob);
                anchor.download = `${fileName}.${fileExtension}`;
                anchor.click();
            }
        } catch (error) {
            console.error('Error while downloading file:', error);
        }
    },
    //to donload problem statement
    downloadProblemStatement(challengePath, competitionTitle) {
        let startIndex = challengePath.lastIndexOf(".");
        let endIndex = challengePath.indexOf("?");
        let fileExtension = challengePath.substring(startIndex, endIndex);
        fetch(challengePath)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = `${competitionTitle}-problem-statement${fileExtension}`;
                    a.click();
                });
            });
    },
    async downloadFileWithLoader(presignedUrl, fileName) {
        try {
            const response = await fetch(presignedUrl);
            if (response.ok) {
                const blob = await response.blob();

                // Create a temporary anchor element to initiate the download
                const anchor = document.createElement('a');
                anchor.href = URL.createObjectURL(blob);
                anchor.download = fileName;
                anchor.click();
                return true;
            } else {
                return true;
            }
        } catch (error) {
            return true;
        }
    },
    //to donload problem statement
    async downloadProblemStatementFile(challengePath, competitionTitle) {
        let startIndex = challengePath.lastIndexOf(".");
        let endIndex = challengePath.indexOf("?");
        let fileExtension = challengePath.substring(startIndex, endIndex);
        try {
            const response = await fetch(challengePath);
            if (response.ok) {
                const blob = await response.blob();
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = `${competitionTitle}-problem-statement${fileExtension}`;
                a.click();
                return true;
            } else {
                return false;
            }
        }
        catch (error) {
            return false;
        }
    },
    async uploadFileThroughPreSignedURL(selectedFile, path, filePermission, fileContentDisposition) {
        const data = {
            objectKey: path,
            contentType: selectedFile.type,
            permissionType: filePermission,
            contentDisposition: fileContentDisposition
        };

        const fileFormData = new FormData();
        fileFormData.append("file", selectedFile);
        const config = {
            'x-amz-acl': filePermission,
            'Content-Disposition': fileContentDisposition,
            'Content-Type': selectedFile.type,
        }
        try {

            const presignedUrlResponse = await DataService.postWithReturnValue(
                AppConstants.getPreSignedURLForUploadAPI,
                data,
                AppConstants.emptyString,
                AppConstants.emptyString
            )
            if (presignedUrlResponse !== undefined && presignedUrlResponse !== null) {
                const start = 1;
                const end = presignedUrlResponse.preSignedURL.length - 1;
                const uploadStatus = await DataService.putFileOnPreSigned(presignedUrlResponse.preSignedURL.substring(start, end),
                    selectedFile,
                    config
                );
                if (uploadStatus.ok) {
                    return presignedUrlResponse;
                }
                else {
                    throw new Error("Error while uploading file", uploadStatus);
                }
            }
        }
        catch (error) {
            console.error('Error while uploading file:', error);
            throw new Error(error);

        }
    },
    async fetchFileBinaryData(fileURL, fileName) {
        return fetch(fileURL)
            .then(response => {
                if (!response.ok) {
                    // cannot fetch file
                    return AppConstants.emptyString;
                }
                return response.arrayBuffer();
            }).then(fileData => {
                const dataTransfer = new DataTransfer();
                if (fileData === AppConstants.emptyString) {
                    return AppConstants.emptyString;
                }
                const [urlWithoutParams] = fileURL.split(AppConstants.questionMark);
                const urlFileName = urlWithoutParams.split(AppConstants.forwardSlash).pop();
                const [name, extension] = urlFileName.split(AppConstants.dot);
                const mimeType = extension ? AppConstants.contentTypeMap[extension.toLowerCase()] : AppConstants.emptyString;
                const file = new File([fileData], `${fileName}.${extension}` || urlFileName, { type: mimeType || AppConstants.s3ContentTypeOctetStream });
                dataTransfer.items.add(file);

                return { dataTransfer, fileURL, name };
            }).catch(error => {
                return AppConstants.emptyString;
            });
    },
    downloadFileBlob(blob, fileName) {
        const anchor = document.createElement('a');
        anchor.href = URL.createObjectURL(blob);
        anchor.download = fileName;
        anchor.click();
        URL.revokeObjectURL(anchor.href);
    },
    downloadCsvDataAsExcel(csvData, fileName) {
        const csvRows = csvData.split('\n').map(row => row.split(AppConstants.agGridColumnSeparator));
        const cleanedData = csvRows.map(row => row.map(cell => cell?.replace(/\r$/, AppConstants.emptyString)));
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(cleanedData);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, fileName);
    }
};